/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * OBJECTS
 */
const Index = ({
  routeId,
  routePlanId,
  routePlanIds,
  onRoutePlanUpdate,
  onRoutePlanDelete,
  PassOnUpdate,
  selectedIds
}) => (
  <Menu placement='left'>
    <MenuButton
      as={Button}
      margin='auto'
      borderRadius='8px'
      color='gray.500'
      bg='transparent'>
      <HiPencil size={18} />
    </MenuButton>
    <MenuList
      className='dropDownMenu'
      maxHeight='400px'
      overflow='auto'>
      <MenuItem
        gap='12px'
        display='flex'
        color='gray.500'
        onClick={() => {
          // Push route id to url.
          PassOnUpdate({ routePlanIds, routePlanId, routeId })

          // Execute handler.
          onRoutePlanUpdate(selectedIds)
        }}
        minH='40px'>
        <HiPencil size={18} />
        <span>Edit Route Plan</span>
      </MenuItem>
      <MenuItem
        gap='12px'
        display='flex'
        color='gray.500'
        onClick={() => {
          // Push route id to url.
          PassOnUpdate({ routePlanIds, routePlanId, routeId })

          // Execute handler.
          onRoutePlanDelete(selectedIds)
        }}
        minH='40px'>
        <HiTrash />
        <span>Delete Route Plan</span>
      </MenuItem>
    </MenuList>
  </Menu>
)


/*
 * PROPTYPES
 */
Index.propTypes = {
  'routeId': PropTypes.string,
  'routePlanId': PropTypes.string,
  'routePlanIds': PropTypes.string,
  'onRoutePlanUpdate': PropTypes.func,
  'onRoutePlanDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'selectedIds': PropTypes.array
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
